// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Retomada_ListaInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * GET /retomada/lista (chamado 2026-0063): por padrao a lista traz so quem falta
 * contatar; `contatados=1` traz tambem as linhas ja contatadas, para conferir ou
 * desfazer uma marcacao.
 */
import { registerContract } from './validate'

export interface Retomada_ListaInput {
contatados?: number
}

registerContract('Retomada_ListaInput', {
  contatados: { type: 'number',  required: false },
})
